import { render, staticRenderFns } from "./reisen-metadata.vue?vue&type=template&id=73016e90&scoped=true"
import script from "./reisen-metadata.vue?vue&type=script&lang=js"
export * from "./reisen-metadata.vue?vue&type=script&lang=js"
import style0 from "./reisen-metadata.vue?vue&type=style&index=0&id=73016e90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73016e90",
  null
  
)

export default component.exports